import { useState } from 'react';

import { Alert, Box, ForaModal, Headings, Text } from '@foradevelopment/fora-ui';
import { dateStringFormatter, getTimeFromDateTimeString } from '@fora-monorepo/date-utils';

import { useTypedTranslation } from '../../i18n/i18n';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { deleteDrafts, getPayReportData, getPayReportDataOld } from '../../redux/payroll/payrollThunks';

export const DraftAlert = () => {
  const { t } = useTypedTranslation();

  const dispatch = useAppDispatch();
  const { payMonth } = useAppSelector(state => state.payroll.selectedPayMonthOverview ?? { payMonth: '' });
  const draftUpdatedAt = useAppSelector(state => state.payroll.draftUpdatedAt);
  const draftTTL = useAppSelector(state => state.foraGlobal.settings.draftTTL);
  const ffManageEmployeeAndEmployment = useAppSelector(
    state => state.foraGlobal.settings.ffManageEmployeeAndEmployment
  );

  const openModal = () => setModalIsOpen(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const closeModal = () => setModalIsOpen(false);

  const resetDraft = () => {
    dispatch(deleteDrafts({ payMonth: payMonth })).then(t => {
      if (ffManageEmployeeAndEmployment) {
        dispatch(getPayReportData({ payMonth: payMonth }));
      } else {
        dispatch(getPayReportDataOld({ payMonth: payMonth }));
      }
    });
  };

  return (
    <Alert
      variant="edit"
      wrap={false}
      hasIcon={true}
      size="slim"
      paddingLeft={[20, 80, 103]}
      paddingRight={[20, 80, 103]}
    >
      <Box>
        <Text size="small">
          {t('warningMessages.activeDraft.text', {
            draftUpdatedAtDate: draftUpdatedAt ? dateStringFormatter(draftUpdatedAt) : '',
            draftUpdateAtTime: draftUpdatedAt ? getTimeFromDateTimeString(draftUpdatedAt) : '',
            draftTTL,
          })}
        </Text>
        <Text size="small">
          {t('warningMessages.activeDraft.text2')}{' '}
          <ForaModal
            isOpen={modalIsOpen}
            openModal={openModal}
            closeModal={closeModal}
            fontSize="small"
            hasIcon={false}
            textColorVariant="dark"
            testId="clear-draft-modal-button"
            label={t('warningMessages.activeDraft.alertClearDraftLinkText')}
          >
            <ForaModal.Content>
              <Headings.H3 marginBottom={20}>{t('modal.draft.title')}</Headings.H3>
              <Text>{t('modal.draft.description')}</Text>
            </ForaModal.Content>
            <ForaModal.Footer
              onActionClick={resetDraft}
              onCancelClick={closeModal}
              cancelButtonText={t('common.cancel')}
              actionButtonText={t('modal.draft.modalClearDraftLinkText')}
              actionButtonVariant="danger"
            />
          </ForaModal>
        </Text>
      </Box>
    </Alert>
  );
};
